import { ButtonLink } from "@/components/Buttons/index";
import { jsx as _jsx } from "react/jsx-runtime";
export default function DetailButton(_ref) {
  let {
    href
  } = _ref;
  return /*#__PURE__*/_jsx(ButtonLink, {
    borderLight: true,
    medium: true,
    fillTransparentGray: true,
    fontBold: true,
    href: href,
    children: "\u8A73\u7D30\u3092\u898B\u308B"
  });
}